import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Outer depth'),"suffix":_vm.value.size_unit,"outlined":"","hide-details":"auto","type":"number"},model:{value:(_vm.outerDepth),callback:function ($$v) {_vm.outerDepth=$$v},expression:"outerDepth"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }